



























































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import Newsletter from '@/store/entities/newsletter'
import simplifyString from "simplify-string";
class  CategoriesPageRequest extends PageRequest{
    keyword:string;
}

@Component({
    components:{}
})
export default class Categories extends AbpBase{
    //filters
    pagerequest:CategoriesPageRequest=new CategoriesPageRequest();
    newsletter:Newsletter = new Newsletter();
    editNewsletter:Newsletter = new Newsletter();
    editIndex:number= -1;
    get list(){
        return this.$store.state.newsletter.list;
    }
    get loading(){
        return this.$store.state.newsletter.loading;
    }
    get pageSize(){
        return this.$store.state.newsletter.pageSize;
    }
    get totalCount(){
        return this.$store.state.newsletter.totalCount;
    }
    get currentPage(){
        return this.$store.state.newsletter.currentPage;
    }
    async create(){
        (this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
                await this.$store.dispatch({
                    type:'newsletter/create',
                    data:this.newsletter
                }).then( () =>{
                    this.newsletter = new Newsletter();
                    this.getpage();
                });
            }
        });
    }
    async save(index){
        this.list[index].email = this.editNewsletter.email;
        this.editIndex = -1;
        this.editNewsletter.id = this.list[index].id;
        await this.$store.dispatch({
            type:'newsletter/update',
            data: this.editNewsletter
        })
    }
    edit(row,index){ 
        let edit = new Newsletter();
        edit.email = row.email;
        this.editNewsletter = edit;
        this.editIndex = index;
    }
    async deleteCat(row,index){
        await this.$store.dispatch({
            type:'newsletter/delete',
            data:row
        }).then( () => {
            this.getpage();
        }) ;           
    }
    pageChange(page:number){
        this.$store.commit('newsletter/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('newsletter/setPageSize',pagesize);
        this.getpage();
    }
    async getpage(){         
        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        await this.$store.dispatch({
            type:'newsletter/getAll',
            data:this.pagerequest
        })
    }
    rules= {
        name: [
            { required: true, message: this.L('PleasefillName'), trigger: 'blur' }
        ]
    }
    columns=[
        {
            title:this.L('Email'),
            slot:'email'
        },
        {
            title: this.L('Action'),
            slot: 'action',
            width: 100
        }
    ]
    async created(){
        this.getpage();
    }
}
